<div class="hvac-select-container hvac-select-checkbox-container" [ngClass]="{
    'hvac-input-min-label': minimizeLabel,
    'hvac-select-primary': variant==='primary',
    'hvac-select-small': size === 'small',
    'hvac-select-no-shadow': shadow === 'none',
    'hvac-select-light-shadow': shadow === 'light',
    'hvac-select-multiple': multiple,
    'hvac-open': isOpen,
    'hvac-disabled': disabled
}" [formGroup]="group" (hvacClickOutside)="handleClick(true)">
    <label *ngIf="valueText?.length === 0" [attr.for]="selectId" class="hvac-input-label">{{ defaultOption }}<abbr
            *ngIf="required" title="required" class="hvac-select-label-required">{{ required ? '*' : ''}}</abbr></label>
    <div class="hvac-select-mask" [ngClass]="{ 'hvac-select-error': error }" (click)="handleClick()">
        <span class="hvac-select-mask-text" [ngClass]="{'hvac-select-mask-text-disbaled': disabled}">{{ valueText
            }}</span>
        <utc-svg class="hvac-select-dropdown-icon" src="assets/icons/chevron-down.svg"></utc-svg>
    </div>
    <ul class="hvac-select-checkbox-options" *ngIf="isOpen" (click)="$event.stopPropagation()">
        <li class="hvac-select-checkbox-option hvac-select-checkbox-option-select-all" *ngIf="showSelectAll">
            <utc-checkbox [checked]="isSelectAllSelected()" [disabled]="disabled"
                [inputId]="(selectId || control) + '-select-all'" [inputName]="control + '-select-all'"
                [value]="'select-all'" (change)="onSelectAllChange($event)">
                <span class="hvac-select-checkbox-option-label">{{ selectAllLabel }}</span>
            </utc-checkbox>
        </li>
        <li class="hvac-select-checkbox-option" *ngFor="let option of options$ | async">
            <utc-checkbox [checked]="isOptionSelected(option)" [disabled]="disabled || option.disabled"
                [inputId]="(selectId || control) + '-' + option.value" [inputName]="control" [value]="option.value"
                (change)="onCheckboxChange($event, option)">
                <span class="hvac-select-checkbox-option-label">{{ option.name || option }}</span>
            </utc-checkbox>
        </li>
    </ul>
    <div *ngIf="(errorMessage && error) || infoMessage" class='hvac-input-message-container hvac-input-show-message'>
        <div *ngIf="errorMessage">
            <utc-svg src="assets/icons/info.svg"></utc-svg>
            <span class='hvac-input-message' [innerHTML]="errorMessage | safe:'html'"></span>
        </div>
        <div *ngIf="infoMessage">
            <span class='hvac-input-message' [innerHTML]="infoMessage | safe:'html'"></span>
        </div>
    </div>
</div>